import { createFileRoute } from '@tanstack/react-router';

import { naturalPersonListSearch, naturalPersonPendingScreen, loadPersonMessages, loadPersonScreens } from '@/modules/person/route';
import { lazyScreen } from '@/shared/screen';

export const Route = createFileRoute('/_app/pessoas-fisicas/pendentes/')({
  validateSearch: naturalPersonListSearch,
  staticData: { screen: naturalPersonPendingScreen },
  loader: () => loadPersonMessages(),
  component: lazyScreen(loadPersonScreens, 'NaturalPersonPendingScreen'),
});
